import React from 'react';
import { motion } from 'framer-motion';
import { User, Cpu, Database, CheckCircle, FileBarChart } from 'lucide-react';

const PlatformOverview = () => {
  const steps = [
    { icon: <User />, label: "User / Channel", id: "user" },
    { icon: <Cpu />, label: "AI Induction Engine", id: "ai" },
    { icon: <Database />, label: "Semantic Knowledge Layer", id: "knowledge" },
    { icon: <CheckCircle />, label: "Autonomous Resolution", id: "resolution" },
    { icon: <FileBarChart />, label: "Audit & Reporting", id: "audit" }
  ];

  return (
    <section id="platform" className="platform-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="title">The AI IT Operations Layer</h2>
          <p className="subtitle">
            Raptic91<sup>™</sup> acts as an intelligent orchestration layer between your users and your infrastructure, automating the entire lifecycle of IT incidents.
          </p>
        </div>

        <div className="architecture-container">
          <div className="arch-flow">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <motion.div
                  className="arch-node"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                >
                  <div className="node-icon">{step.icon}</div>
                  <div className="node-label">{step.label}</div>
                </motion.div>
                {index < steps.length - 1 && (
                  <motion.div
                    className="arch-arrow"
                  >
                    <div className="arrow-line"></div>
                  </motion.div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="platform-features">
          <div className="p-feat">
            <h4>Autonomous Classification</h4>
            <p>Instantly understands intent, urgency, and technical context using LLMs trained on millions of IT tickets.</p>
          </div>
          <div className="p-feat">
            <h4>Context-Aware Diagnosis</h4>
            <p>Cross-references historical data and system logs to identify root causes with 98% accuracy.</p>
          </div>
          <div className="p-feat">
            <h4>Smart Assignment</h4>
            <p>Dynamically routes complex edge cases to the right human expert based on skills and availability.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformOverview;
